import { render, staticRenderFns } from "./pathogenesis_analysis.vue?vue&type=template&id=3ef878a0&scoped=true"
import script from "./pathogenesis_analysis.vue?vue&type=script&lang=js"
export * from "./pathogenesis_analysis.vue?vue&type=script&lang=js"
import style0 from "./pathogenesis_analysis.vue?vue&type=style&index=0&id=3ef878a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef878a0",
  null
  
)

export default component.exports